import React, { useEffect } from 'react'
import { Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Wrapper } from '../utils/RolesandAccess';
import { AuditScheduleIndex, ImplementationChecklistIndex, InternalAuditChecklistIndex, MainActivity, MaintenanceIndex, MasterListOfDocumentIndex, MOMIndex } from '../pages/Activity';
import PageNotFound from '../components/View/PageNotFound';

function ActivityRoutes() {
    const { stdId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
  
    useEffect(() => {
  
      if (location.pathname === `/standard/${stdId}/activity/`||location.pathname === `/standard/${stdId}/activity`) {
        navigate(`/standard/${stdId}/activity/implementation-checklist`, { replace: true });
      }
      console.log(stdId);
    }, [location.pathname, stdId, navigate]);
  return (
    <Routes>
     <Route path="/" element={<Wrapper accessKey={stdId} Component={MainActivity} />}>
      <Route path="implementation-checklist" element={<Wrapper accessKey={stdId} Component={ImplementationChecklistIndex} />} />
      <Route path="master-list-of-documents" element={<Wrapper accessKey={stdId} Component={MasterListOfDocumentIndex} />} />
      <Route path="audit-schedule" element={<Wrapper accessKey={stdId} Component={AuditScheduleIndex} />} />
      <Route path="internal-audit-checklist" element={<Wrapper accessKey={stdId} Component={InternalAuditChecklistIndex} />} />
      <Route path="ciso-mom" element={<Wrapper accessKey={stdId} Component={MOMIndex} />} />
      <Route path="maintenance" element={<Wrapper accessKey={stdId} Component={MaintenanceIndex} />} />
     </Route>
     <Route path="/*" element={<PageNotFound/>} />
    </Routes>
  )
}


export default ActivityRoutes